let accessToken = null;
let tokenExpiresIn = null;
let inflight = null;

const SAFETY_MS = 30 * 1000;

const authEndPoint = () => `${(process.env.REACT_APP_SERVER_API_URL || '').trim()}/auth/token`;

const parseExpiryMs = raw => {
  if (raw === null) return 16 * 60 * 1000;
  if (typeof raw === 'number') return raw * 1000;
  const m = String(raw)
    .trim()
    .toLowerCase()
    .match(/^(\d+)(s|m|h|d)?$/);
  if (!m) return 15 * 60 * 1000;
  const n = Number(m[1]);
  const u = m[2] || 's';
  if (u === 'd') return n * 24 * 60 * 60 * 1000;
  if (u === 'h') return n * 60 * 60 * 1000;
  if (u === 'm') return n * 60 * 1000;
  return n * 1000;
};

const hasValidToken = () => Boolean(accessToken) && Date.now() < tokenExpiresIn - SAFETY_MS;
async function fetchToken() {
  const clientId = (process.env.REACT_APP_JWT_CLIENT_ID || '').trim();
  const clientSecret = (process.env.REACT_APP_JWT_CLIENT_SECRET || '').trim();
  if (!clientId || !clientSecret) {
    throw new Error('Missing Client ID or Client Secret');
  }

  const res = await fetch(authEndPoint(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ clientId, clientSecret }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || `Token request failed (${res.status})`);

  const token = data?.data?.accessToken;
  if (!token) throw new Error('No accessToken in response');

  accessToken = token;
  tokenExpiresIn = Date.now() + parseExpiryMs(data?.data?.expiresIn);
  return accessToken;
}

export async function ensureAccessToken({ forceRefresh = false } = {}) {
  if (!forceRefresh && hasValidToken()) return accessToken;
  if (!inflight) {
    inflight = fetchToken().finally(() => {
      inflight = null;
    });
  }
  return inflight;
}

export function clearAccessToken() {
  accessToken = null;
  tokenExpiresIn = 0;
}
